export default function TikTokIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.25-.02-.5-.03-.76-.01-.04.53-.42.53-.42 1.32-.89 3.02-1.34 4.61-1.04.75.14 1.47.44 2.11.88.01-3.14-.01-6.28.01-9.42-.05-1.74.54-3.49 1.66-4.83C9.94 1.44 11.23.71 12.53.02z" />
    </svg>
  );
}
